// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getGroupType } from '../../groups/notificationGroupUtils';

// Components
import NotificationGroupElement from './NotificationGroupElement';
import NotificationGroupTemplate from './NotificationGroupTemplate';
import NotificationGroupGeneral from './NotificationGroupGeneral';

// Constants
import { NOTIFICATION_GROUP_TYPES } from '../entry/utils/notificationEntryConstants';

const NotificationGroup = (props) => {
    const { group } = props;

    const type = getGroupType(group);

    switch (type) {
        case NOTIFICATION_GROUP_TYPES.ELEMENT:
            return <NotificationGroupElement {...props} />;
        case NOTIFICATION_GROUP_TYPES.TEMPLATE:
            return <NotificationGroupTemplate {...props} />;
        case NOTIFICATION_GROUP_TYPES.GENERAL:
            return <NotificationGroupGeneral {...props} />;
        default:
            return null;
    }
};

NotificationGroup.propTypes = {
    group: PropTypes.object,
};

export default NotificationGroup;
